import axios from "axios";

export const httpClientForIframe = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}/collection`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const backendClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
